<template>
  <div class="flex flex-col gap-4">
    <TranscriptionUpsellingInline v-if="showAiAddonUpsellingInline" :is-new-plan="isNewPlanWithoutAi" @close="closeAIAddon" />
    <TranscriptionEmpty v-if="showNoAudioEmptyState" />
    <template v-else-if="isTranscriptionGenerated && !isEditProcessing && (!isCurrentItemOwner || !isNewPlanWithoutAi)">
      <template v-if="isTranscriptionFinished">
        <TranscriptionRetry v-if="isTranscriptionFailed" />
        <TranscriptionWrapper v-else />
      </template>
      <TranscriptionProcessing v-else-if="isTranscriptionProcessing" />
    </template>

    <TranscriptionVideoProcessing v-else-if="isEditProcessing" />
    <TranscriptionRequest v-else-if="hasAiAddon && isCurrentItemOwner" />
    <TranscriptionUpselling v-else-if="isCurrentItemOwner" :is-new-plan="isNewPlanWithoutAi" />
  </div>
</template>

<script lang="ts" setup>
import { useTranscriptionStore } from '@/modules/viewer/store/useTranscriptionStore';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { storeToRefs } from 'pinia';
import { computed, onBeforeMount, ref } from 'vue';

import TranscriptionRequest from './TranscriptionRequest.vue';
import TranscriptionEmpty from './TranscriptionEmpty.vue';
import TranscriptionUpselling from './TranscriptionUpselling.vue';
import TranscriptionWrapper from './general/TranscriptionWrapper.vue';
import TranscriptionRetry from './TranscriptionRetry.vue';
import TranscriptionProcessing from './TranscriptionProcessing.vue';
import TranscriptionVideoProcessing from './TranscriptionVideoProcessing.vue';
import TranscriptionUpsellingInline from './TranscriptionUpsellingInline.vue';

import { useVideoAi } from '@/modules/viewer/composables/useVideoAi';
import { useUser } from '@/modules/viewer/composables/useUser';

const transcriptionStore = useTranscriptionStore();
const store = useViewerItemStore();

const { isCurrentItemOwner } = useUser();
const { hasAiAddon, isNewPlanWithoutAi, hasTranscriptionEntitlement } = useVideoAi();

const { isEditProcessing, hasAudioStream } = storeToRefs(store);
const { isTranscriptionGenerated, isTranscriptionFinished, isTranscriptionFailed, isTranscriptionProcessing } = storeToRefs(transcriptionStore);

const showAiAddon = ref(true);

const closeAIAddon = () => {
  showAiAddon.value = false;
};
const showAiAddonUpsellingInline = computed(() => {
  return isCurrentItemOwner.value && !hasAiAddon.value && !isTranscriptionFinished.value && showAiAddon.value;
});

// "No voice detected" applies only when the user is entitled to transcription
// AND the video has no audio stream. Without the entitlement gate, Share-plan
// (and any account with the viewer-transcription LD flag off) would see the
// message on every no-audio video even though no transcription was attempted.
const showNoAudioEmptyState = computed(() => !hasAudioStream.value && hasTranscriptionEntitlement.value);

onBeforeMount(() => transcriptionStore.loadTranscription(transcriptionStore.transcriptionId));
</script>
